import { ReactElement, useState } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { BiLogOut } from 'react-icons/bi';
import { Link, Navigate } from 'react-router-dom';
import Protec from '../../assets/Images/protec.svg';

import styles from './Header.module.scss';

import axios from 'axios';
import { toast } from 'react-toastify';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import './Breadcrumb.scss';

interface IHeaderProps {
  breadcrumb?: IBreadcrumbProps[];
  actions?: ReactElement;
}

export interface IBreadcrumbProps {
  name: string;
  path: string;
  active?: boolean;
}

const Header = ({ breadcrumb, actions }: IHeaderProps) => {
  const [logout, setLogout] = useState(false);

  const handleLogout = () => {
    axios
      .post('/api/account/logout', undefined, { withCredentials: true })
      .then(() => {
        setLogout(true);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message ?? err.response?.data ?? 'Unable to logout');
      });
  };

  return (
    <header>
      <Navbar expand="lg" className={styles.Header} fixed="top">
        <Container fluid>
          <Navbar.Brand>
            <img src={Protec} alt="Protection Civile" className={styles.Logo} />
            <span>Protec'App</span>
          </Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <Nav>
              <Nav.Link as={Link} to="/addresses">Addresses</Nav.Link>
              <Nav.Link as={Link} to="/activity-types">Activities</Nav.Link>
              <Nav.Link onClick={handleLogout}>
                <IconWrapper icon={BiLogOut} size={25} />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className={styles.Empty}></div>
      {breadcrumb && breadcrumb.length > 0 && (
        <div className={styles.SubHeader}>
          <Breadcrumb>
            {breadcrumb.map((link, id) => (
              <Breadcrumb.Item
                key={id}
                active={link.active}
                linkAs={Link}
                linkProps={{ to: link.active ? undefined : link.path }}
              >
                {link.name}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
          <div>{actions}</div>
        </div>
      )}
      {logout && <Navigate to="/login" />}
    </header>
  );
};

export default Header;
